// extracted by mini-css-extract-plugin
module.exports = {"featured-offers":"FeaturedOffers_featured-offers__YIkrF","featured-offers__container":"FeaturedOffers_featured-offers__container__ktN1K"};